import './assets/styles/index.css';

import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import App from './App.vue';
import i18nPlugin from '@/plugins/i18n';
import router from '@/router';

const app = createApp(App);
const head = createHead();

app.use(router).use(i18nPlugin).use(head).mount('#app');
